import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const DocumentsFormQuestion = ({
  className,
  children,
  error,
  helpText,
  name,
  fieldsWithError,
  serverCarrierData,
  extraClass,
}) => {
  const isDisabled =
    !!serverCarrierData[name] || !!serverCarrierData.billing_address?.[name];
  return (
    <div
      className={cx(
        className,
        'documents-form-question',
        `documents-form-question--${name}`,
        extraClass,
        { 'documents-form-question--error': fieldsWithError[name] },
        { 'documents-form-question--disabled': isDisabled }
      )}
      data-testid="documents-form-question"
    >
      {children}
      {fieldsWithError[name] && error && (
        <span className="documents-form-question__error">{error}</span>
      )}
      {helpText && (
        <span className="documents-form-question__question-help">
          {helpText}
        </span>
      )}
    </div>
  );
};
DocumentsFormQuestion.defaultProps = {
  error: '',
  helpText: '',
  fieldsWithError: {},
  serverCarrierData: {},
  extraClass: '',
  className: '',
};

DocumentsFormQuestion.propTypes = {
  children: PropTypes.any.isRequired,
  error: PropTypes.string,
  helpText: PropTypes.string,
  name: PropTypes.string.isRequired,
  fieldsWithError: PropTypes.object,
  serverCarrierData: PropTypes.object,
  extraClass: PropTypes.string,
  className: PropTypes.string,
};
export default DocumentsFormQuestion;
